export const packagedeals = $state({
  lAvailablePackageDeals: [], // de lijst die met de ajax call voor deze dag terug komt uit het backend (bIsAvailable, iPrice, sPriceString updated by Phase 2)
  aRecommendedPackageDealIDs: [],
  lItems: [],

  // Phase 1: Content (HTML without availability)
  bIsFetchingPackageDealsContent: false,
  bHasPackageDealsContent: false,
  sPackageDealsContentHTML: '',

  // Phase 2: Availability - flags only (data is merged into lAvailablePackageDeals)
  bIsFetchingPackageDealsAvailability: false,
  bHasPackageDealsAvailability: false,

  // Pending preselection: when a preselected package deal needs to wait for Phase 2 availability
  // This is set in addPerson() when iPreselectedPackageDealID exists but Phase 2 hasn't completed yet
  iPendingPreselectedPackageDealID: false,

  // Pending user click: when user clicks "Toevoegen" before Phase 2 availability is ready
  // This is set by addOrReplacePackageDealWithAvailabilityCheck() when availability hasn't loaded yet
  iPendingUserClickPackageDealID: false
});

window.hmk_packagedeals = () => {
  console.log($state.snapshot(packagedeals))
}
